(function () {
    'use strict';

    var moduleKey = 'cylindo.core.util';
    var util = window.cylindo.getModule(moduleKey) || {};
    var fullscreenMaps = {
        request: [
            'requestFullscreen',
            'webkitRequestFullscreen',
            'mozRequestFullScreen',
            'msRequestFullscreen'
        ],
        exit: [
            'exitFullscreen',
            'webkitExitFullscreen',
            'mozCancelFullScreen',
            'msExitFullscreen'
        ],
        change: [
            'onfullscreenchange',
            'onwebkitfullscreenchange',
            'onmozfullscreenchange',
            'onmsfullscreenchange',
            'MSFullscreenChange'
        ],
        element: [
            'fullscreenElement',
            'webkitFullscreenElement',
            'mozFullScreenElement',
            'msFullscreenElement'
        ]
    };
    function getFullScreenFn(names) {
        var fn = null;
        names.every(function (f) {
            if (typeof document[f] !== 'undefined' || typeof document.body[f] !== 'undefined') {
                if (f === 'onmsfullscreenchange' &&
                    util.browser.browser.name === 'Internet Explorer' &&
                    util.browser.browser.version === '11.0') {
                    f = 'MSFullscreenChange';
                }
                fn = f;
                return false;
            }
            return true;
        });
        return fn;
    }
    util.fullscreenMap = {
        request: getFullScreenFn(fullscreenMaps.request),
        exit: getFullScreenFn(fullscreenMaps.exit),
        change: getFullScreenFn(fullscreenMaps.change),
        element: getFullScreenFn(fullscreenMaps.element),
    };
    window.cylindo.addModule(moduleKey, util);
}).call(this); 